import { render, staticRenderFns } from "./SkuPlatform.vue?vue&type=template&id=1557cdc3&scoped=true&"
import script from "./SkuPlatform.vue?vue&type=script&lang=js&"
export * from "./SkuPlatform.vue?vue&type=script&lang=js&"
import style0 from "./SkuPlatform.vue?vue&type=style&index=0&id=1557cdc3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1557cdc3",
  null
  
)

export default component.exports